//--------------------------------------------------
// imported classes
//--------------------------------------------------
/**
 * The SceneBridge class works as the bridge
 * connected the scene instance with the business logic.
 * It provides the easy and flexible approaches to do interact.
 * By bridge, the business logic layer could access the authorized
 * properties and methods.
 * By bridge, the business logic layer even could use high level APIs 
 * to perform well.
 */
const tbs_core_ModelTranslator = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_core_ModelTranslator.prototype = {
    //--------------------------------------------------
    // api
    //--------------------------------------------------
    /**
     * @api
     * Validate the scene is collection type or not.
     * Check the route name contains 'List' string or not.
     * @return The boolean result
     */
    localeProp: function(key, prop) {
        let item = this[key] || ''
        if (prop) {
            for (let p in prop) {
                item = item.replaceAll('$' + p, prop[p] ? prop[p] : '')
                item = this.transferLocaleProp(item)
            }
        }
        return item
    },
    transferLocaleProp: function(item) {
        while (item.indexOf('${') > -1) {
            const startIndex = item.indexOf('${')
            const endIndex = item.indexOf('}', startIndex)
            const hitValAttr = item.substring(startIndex + 2, endIndex)
            item = item.replace('${' + hitValAttr + '}', this[hitValAttr])
        }
        return item
    }
}

module.exports = tbs_core_ModelTranslator